module.exports = __webpack_public_path__ + "static/img/toubiao.17001219.png";